import actionTypes from "../actionTypes";
import {strict} from "assert";
import {IParcela} from "../../types";
import {LatLngTuple} from "leaflet";

const update = require('immutability-helper');


export const initialState = {
    riego: {} as Record<string, Record<string, number>>,
    pronostico: {} as Record<string, Record<string, number>>,
    historico: {} as Record<string, Record<string, number>>,
    metodo: 'fao' as string,
    parcela: {} as IParcela,
    sectores: {} as Record<string, LatLngTuple[]>,
    sector: '' as string
};

export function reducer(state: typeof initialState=initialState, action: actionTypes) {
    switch (action.type) {
        case 'set-riego-riego':
            return update(state, {riego: {$set: action.riego}});

        case 'set-riego-pronostico':
            return update(state, {pronostico: {$set: action.pronostico}});

        case 'set-riego-historico':
            return update(state, {historico: {$set: action.historico}});

        case 'set-riego-metodo':
            return update(state, {metodo: {$set: action.metodo}});

        case 'set-riego-parcela':
            return update(state, {parcela: {$set: action.parcela}});

        case 'set-riego-sectores':
            return update(state, {sectores: {$set: action.sectores}});

        case 'set-riego-sector':
            return update(state, {sector: {$set: action.sector}});

        default:
            return state
    }
}